import { DevicesAppBaseDataProvider } from './DevicesAppBaseDataProvider';
import { DevicesAppWebComponentSchema } from '../types';

export class DevicesAppNirvanaDataProvider extends DevicesAppBaseDataProvider {
  async getDataForView(): Promise<DevicesAppWebComponentSchema> {
    return {} as unknown as DevicesAppWebComponentSchema;
  }
}
